import { gql } from '@apollo/client'

export const GET_IP_ACCESS_RULES_QUERY = gql`
  query IPAccessRules($input: IPAccessRulesInput!) {
    ipAccessRules(input: $input) {
      rules {
        id
        scope
        effect
        canonicalCidr
        enabled
        reason
        entityType
        entityId
        entityCode
        userId
        revision
      }
      pagination {
        page
        perPage
        total
      }
    }
  }
`

export const CREATE_IP_ACCESS_RULE_MUTATION = gql`
  mutation CreateIPAccessRule($input: CreateIPAccessRuleInput!) {
    createIPAccessRule(input: $input) {
      id
      revision
    }
  }
`

export const UPDATE_IP_ACCESS_RULE_MUTATION = gql`
  mutation UpdateIPAccessRule($input: UpdateIPAccessRuleInput!) {
    updateIPAccessRule(input: $input) {
      id
      revision
    }
  }
`

export const DELETE_IP_ACCESS_RULE_MUTATION = gql`
  mutation DeleteIPAccessRule($input: DeleteIPAccessRuleInput!) {
    deleteIPAccessRule(input: $input) {
      message
      revision
    }
  }
`
